import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiSecurityQuestions } from '../../services/api';
import { SecurityQuestion } from '../../services/types/apitypes';
import AppLoading from '../../components/AppLoading';

import './SecurityQuestions.css';

type SecurityQuestionsProps = {
  selectQuestion: (s: SecurityQuestion) => void;
  excludedQuestions?: number[];
};

export default function SecurityQuestions({
  selectQuestion,
  excludedQuestions,
}: SecurityQuestionsProps) {
  const [t] = useTranslation('global');

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [questions, setQuestions] = useState<SecurityQuestion[]>([]);

  useEffect(() => {
    setIsLoading(true);
    apiSecurityQuestions().then(
      (response) => {
        setIsLoading(false);
        let questions = response.data;
        if (excludedQuestions) {
          questions = questions.filter(
            (q: SecurityQuestion) =>
              !excludedQuestions?.includes(q.id),
          );
        }
        setQuestions(questions);
      },
      (error) => {
        console.log(error);
        setIsLoading(false);
      },
    );
  }, []);

  return (
    <>
      <AppLoading hidden={!isLoading}></AppLoading>
      <p className="pt-2 pb-3 instructions ion-text-center">
        {t('register.questionsinfo')}
      </p>
      <div className="register-questions-list">
        {questions.map((q: SecurityQuestion, i: number) => {
          return (
            <div onClick={() => selectQuestion(q)} key={i}>
              {q.value}
            </div>
          );
        })}
      </div>
    </>
  );
}
